import React, { useState, useEffect, useContext } from 'react';
import { Link, useParams, useNavigate } from 'react-router-dom';
import { format } from 'date-fns';
import { ToastContainer, toast } from 'react-toastify';
import add from '../../assest/images/add.png';
import Icon5 from '../../assest/images/Icon5.png';
import Select from 'react-select';
import { Modal } from 'react-bootstrap';
import { UserContext } from '../common/UserContext';
import config from "../../envconfig";
import { IoCaretDownOutline, IoCaretUpOutline } from 'react-icons/io5';
import 'react-datepicker/dist/react-datepicker.css';
import DatePicker from 'react-datepicker';

function ShipmentReturnUpdate() {
    const [returnReason, setReturnReason] = useState('');
    const [shipmentDate, setShipmentDate] = useState(new Date());
    const [logisticParty, setLogisticParty] = useState([]);
    const [selectedLogisticPartyId, setSelectedLogisticPartyId] = useState('');
    const [vehicleNumber, setVehicleNumber] = useState('');
    const [vehicleOptions, setVehicleOptions] = useState([]);
    const [scpOptions, setScpOptions] = useState([]);
    const [selectedSCPName, setSelectedSCPName] = useState('');
    const [selectedSCPCode, setSelectedSCPCode] = useState('');
    const [shipmentCodes, setShipmentCodes] = useState([]);
    const [tableRecords, setTableRecords] = useState([]);
    const [initialTableRecords, setInitialTableRecords] = useState([]);
    const [selectedShipmentCode, setSelectedShipmentCode] = useState('');
    const [text, setText] = useState('');
    const [invalidQuantities, setInvalidQuantities] = useState([]);
    const [returnReasonOptions, setReturnReasonOptions] = useState([]);
    const [showModal, setShowModal] = useState(false);
    const [modalSelectedDate, setModalSelectedDate] = useState('');
    const [isSCPNameEmpty, setIsSCPNameEmpty] = useState(false);
    const [isShipmentCodeEmpty, setIsShipmentCodeEmpty] = useState(false);
    const [isReasonEmpty, setIsReasonEmpty] = useState(false);
    const [isLogisiticEmpty, setIsLogisticEmpty] = useState(false);
    const [confirmRemoveIndex, setConfirmRemoveIndex] = useState(null);
    const [showConfirmModal, setShowConfirmModal] = useState(false);
    const [isSelectOpen, setIsSelectOpen] = useState(null);
    const [loading, setLoading] = useState(false);
    const { UM_GroupId, UM_CompanyGrpID, selectedScpId, UM_CompanyID, UM_UserId, UM_UserCode } = useContext(UserContext);
    const { shipmentCode } = useParams();
    const navigate = useNavigate();

    const handleSelectOpen = (selectName) => {
        setIsSelectOpen(selectName);
    };

    const handleSelectClose = () => {
        setIsSelectOpen(null);
    };

    useEffect(() => {
        sessionStorage.setItem('UM_GroupId', UM_GroupId);
        sessionStorage.setItem('UM_CompanyGrpID', UM_CompanyGrpID);
        sessionStorage.setItem('UM_DefaultSCPId', shipmentCode);
        sessionStorage.setItem('UM_CompanyID', UM_CompanyID);
        sessionStorage.setItem('UM_UserId', UM_UserId);
        sessionStorage.setItem('UM_UserCode', UM_UserCode);
        sessionStorage.setItem('selectedScpId', selectedScpId);
    }, [UM_GroupId, UM_CompanyGrpID, shipmentCode, UM_CompanyID, UM_UserId, UM_UserCode, selectedScpId]);

    const logAction = async (action, isError = false) => {
        try {
            const response = await fetch(`${config.API_URL}/api/log`, {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify({ module: 'Shipment Return Creation:', action, userCode: UM_UserCode, isError }),
            });
            if (!response.ok) throw new Error('Failed to log action');
        } catch (error) {
            console.error('Error logging action:', error);
        }
    };

    useEffect(() => {
        const fetchVehicleNumbers = async () => {
            try {
                if (selectedLogisticPartyId !== '') {
                    setTimeout(async () => {
                        const response = await fetch(`${config.API_URL}/logisticcompany/vehicles/${selectedLogisticPartyId}`);
                        const data = await response.json();
                        setVehicleOptions(data.vehicleData);
                    }, 1000);
                }
            } catch (error) {
                console.error('Error fetching vehicle numbers:', error);
                setVehicleOptions([]);
            }
        };
        fetchVehicleNumbers();
    }, [selectedLogisticPartyId]);

    useEffect(() => {
        if (selectedSCPName !== '' && selectedScpId !== '') {
            fetchShipmentCodes(selectedSCPCode, selectedScpId);
        }
    }, [selectedSCPName, selectedScpId, selectedSCPCode]);

    useEffect(() => {
        if (UM_CompanyID) {
            fetchLogisticParty(selectedScpId);
            fetchSCPOptions(selectedScpId);
        }
        fetch(`${config.API_URL}/enumtype/returnreason`)
            .then((response) => response.json())
            .then((data) => {
                setReturnReasonOptions(data);
            })
            .catch((error) => {
                console.error('Error fetching return reasons:', error);
            });
    }, [UM_CompanyID, selectedScpId]);

    useEffect(() => {
        const fetchInitialData = async () => {
            try {
                const detailsResponse = await fetch(`${config.API_URL}/shipmentreturnupdate/${shipmentCode}`);
                if (!detailsResponse.ok) throw new Error('Failed to fetch shipment details');
                const detailsData = await detailsResponse.json();
                console.log('Shipment Details:', detailsData);

                if (detailsData.shipmentDetails) {
                    setReturnReason(detailsData.shipmentDetails.SHPR_ReturnReason);
                    const rawDate = detailsData.shipmentDetails.SHPR_ShipmentDate;
                    const [dd, mm, yyyy] = rawDate.split('-');
                    const formattedDate = `${yyyy}-${mm}-${dd}`;
                    setShipmentDate(formattedDate);
                    setSelectedLogisticPartyId(detailsData.shipmentDetails.SHPR_LogisticPartyID);
                    setSelectedSCPCode(detailsData.shipmentDetails.SHPR_SCPCode);
                    setSelectedSCPName(detailsData.shipmentDetails.SCPM_Name);
                    setText(detailsData.shipmentDetails.SHPR_ReturnRemarks);
                    setVehicleNumber(detailsData.shipmentDetails.SHPR_LogisticVehicleID);
                    console.log('SCP Code', detailsData.shipmentDetails.SHPR_SCPCode);

                    const tableDataResponse = await fetch(`${config.API_URL}/shipmentreturn/tableData/${shipmentCode}`);
                    if (!tableDataResponse.ok) throw new Error('Failed to fetch table data');
                    const tableData = await tableDataResponse.json();

                    const initialTableRecords = tableData.tableData.map((record) => ({
                        SHPD_ShipmentMID: record.SHPD_ShipmentMID,
                        SCPCode: detailsData.shipmentDetails.SHPR_SCPCode,
                        SCPName: detailsData.shipmentDetails.SCPM_Name,
                        ShipmentCode: record.SHPDR_ShipmentCode,
                        ProductName: record.SHPDR_ProductName,
                        ProductCode: record.SHPDR_ProductCode,
                        ReceivedQuantity: record.SHPDR_ReceivedQty,
                        RemainingQuantity: record.RemainingQty,
                        originalRemainingQty: record.RemainingQty,
                        originalReturnQty: record.SHPDR_ShipQty,
                        ReturnQuantity: record.SHPDR_ShipQty,
                    }));
                    setTableRecords(initialTableRecords);
                    setInitialTableRecords(initialTableRecords);
                } else {
                    throw new Error('shipmentDetails not found in response');
                }
            } catch (error) {
                console.error('Error fetching initial data:', error);
            }
        };
        fetchInitialData();
    }, [shipmentCode]);

    const fetchLogisticParty = (companyID) => {
        fetch(`${config.API_URL}/shipment/logisticcompany/${companyID}`)
            .then((response) => response.json())
            .then((data) => {
                setLogisticParty(data.logisticCompany);
                setVehicleOptions([]);
            })
            .catch((error) => {
                console.error('Error fetching logistic company data:', error);
            });
    };

    const fetchSCPOptions = (selectedScpId) => {
        fetch(`${config.API_URL}/shipmentmaster/scpcode/${selectedScpId}`)
            .then((response) => response.json())
            .then((data) => {
                setScpOptions(data.SCPNames);
                console.log(data);
            })
            .catch((error) => {
                console.error('Error fetching shipment options:', error);
            });
    };

    const fetchShipmentCodes = (selectedSCPName, selectedScpId) => {
        fetch(`${config.API_URL}/shipmentlist/shipmentcodes/${selectedScpId}/${selectedSCPName}`)
            .then((response) => response.json())
            .then((data) => {
                setShipmentCodes(data.shipmentCodes);
            })
            .catch((error) => {
                console.error('Error fetching shipment codes:', error);
            });
    };

    const handleLogisticPartyChange = async (selectedOption) => {
        const selectedPartyId = selectedOption ? selectedOption.value : '';
        setSelectedLogisticPartyId(selectedPartyId);
        try {
            const response = await fetch(`${config.API_URL}/logisticcompany/vehicles/${selectedPartyId}`);
            if (!response.ok) throw new Error('Failed to fetch vehicle numbers');
            const data = await response.json();
            setVehicleOptions(data.vehicleData);
        } catch (error) {
            console.error('Error fetching vehicle numbers:', error);
            setVehicleOptions([]);
        }
    };

    const handleSCPChange = (selectedOption) => {
        const selectedSCP = scpOptions.find((scp) => scp.SCPM_Name === selectedOption?.value);
        if (selectedSCP) {
            setSelectedSCPName(selectedSCP.SCPM_Name);
            console.log('selectedSCP.SCPM_Name', selectedSCP.SCPM_Name);
            setIsSCPNameEmpty(false);
            setSelectedSCPCode(selectedSCP.SHPD_SCPCode);
            fetchShipmentCodes(selectedSCP.SHPD_SCPCode, selectedScpId);
        } else {
            setSelectedSCPName('');
            setShipmentCodes([]);
        }
    };

    const handleShipmentCodeChange = (selectedOption) => {
        const selectedCode = selectedOption ? selectedOption.value : '';
        setSelectedShipmentCode(selectedCode);
        setIsShipmentCodeEmpty(false);
    };

    const handleChange = (e) => {
        const text = e.target.value;
        setText(text);
        e.target.style.height = 'auto';
        e.target.style.height = e.target.scrollHeight + 'px';
    };

    const handleAddAllToTable = async () => {
        try {
            if (selectedSCPName === '') {
                setIsSCPNameEmpty(true);
                toast.error('Please select a SCP Name.');
                return;
            } else {
                setIsSCPNameEmpty(false);
            }

            if (shipmentCodes.length === 0) {
                toast.error('No shipment codes available for the selected SCP.');
                return;
            }

            let allCodesAlreadyExist = true;
            for (const code of shipmentCodes) {
                if (!tableRecords.some((record) => record.ShipmentCode === code)) {
                    allCodesAlreadyExist = false;
                    break;
                }
            }

            if (allCodesAlreadyExist) {
                toast.error('All shipment codes are already present in the table.');
                return;
            }

            const findInitialRecord = (shipmentCode, productCode, scpName) => {
                return initialTableRecords.find(
                    (record) =>
                        record.ShipmentCode === shipmentCode &&
                        record.ProductCode === productCode &&
                        record.SCPName === scpName
                );
            };

            for (const code of shipmentCodes) {
                if (tableRecords.some((record) => record.ShipmentCode === code)) continue;

                const selectedSCP = scpOptions.find((scp) => scp.SCPM_Name === selectedSCPName);
                if (!selectedSCP) throw new Error('Selected SCP not found');

                const response = await fetch(`${config.API_URL}/shipmentmaster/details/${code}`);
                if (!response.ok) throw new Error(`Failed to fetch shipment details for code ${code}`);
                const data = await response.json();
                const { shipmentDetails } = data;

                shipmentDetails.forEach((detail) => {
                    const initialRecord = findInitialRecord(code, detail.SHPD_ProductCode, selectedSCPName);
                    setTableRecords((prevRecords) => [
                        ...prevRecords,
                        {
                            SHPD_ShipmentMID: detail.SHPD_ShipmentMID,
                            SCPCode: selectedSCP.SHPD_SCPCode,
                            SCPName: selectedSCPName,
                            ShipmentCode: code,
                            ProductName: detail.SHPD_ProductName,
                            ProductCode: detail.SHPD_ProductCode,
                            ReceivedQuantity: detail.SHPD_ReceivedQty,
                            RemainingQuantity: detail.RemainingQty,
                            originalRemainingQty: detail.RemainingQty,
                            originalReturnQty: initialRecord ? initialRecord.originalReturnQty : 0,
                            ReturnQuantity: initialRecord ? initialRecord.ReturnQuantity : '',
                        },
                    ]);
                });
            }
        } catch (error) {
            console.error('Error adding all records to table:', error);
            toast.error(`Error adding all records to table: ${error.message}`);
        }
    };

    const handleAddToTable = async () => {
        try {
            if (selectedSCPName === '') setIsSCPNameEmpty(true);
            else setIsSCPNameEmpty(false);
            if (selectedShipmentCode === '') setIsShipmentCodeEmpty(true);
            else setIsShipmentCodeEmpty(false);

            if (selectedSCPName === '' || selectedShipmentCode === '') return;

            if (tableRecords.some((record) => record.ShipmentCode === selectedShipmentCode)) {
                console.log('Record already exists in the table for this shipment code');
                toast.error(`Shipment Code ${selectedShipmentCode} already exists in the table.`);
                return;
            }

            const selectedSCP = scpOptions.find((scp) => scp.SCPM_Name === selectedSCPName);
            if (!selectedSCP) throw new Error('Selected SCP not found');

            const response = await fetch(`${config.API_URL}/shipmentmaster/details/${selectedShipmentCode}`);
            if (!response.ok) throw new Error('Failed to fetch shipment details');
            const data = await response.json();
            const { shipmentDetails } = data;

            const findInitialRecord = (shipmentCode, productCode, scpName) => {
                return initialTableRecords.find(
                    (record) =>
                        record.ShipmentCode === shipmentCode &&
                        record.ProductCode === productCode &&
                        record.SCPName === scpName
                );
            };

            shipmentDetails.forEach((detail) => {
                const initialRecord = findInitialRecord(selectedShipmentCode, detail.SHPD_ProductCode, selectedSCPName);
                setTableRecords((prevRecords) => [
                    ...prevRecords,
                    {
                        SHPD_ShipmentMID: detail.SHPD_ShipmentMID,
                        SCPCode: selectedSCP.SHPD_SCPCode,
                        SCPName: selectedSCPName,
                        ShipmentCode: selectedShipmentCode,
                        ProductName: detail.SHPD_ProductName,
                        ProductCode: detail.SHPD_ProductCode,
                        ReceivedQuantity: detail.SHPD_ReceivedQty,
                        RemainingQuantity: detail.RemainingQty,
                        originalRemainingQty: detail.RemainingQty,
                        originalReturnQty: initialRecord ? initialRecord.originalReturnQty : 0,
                        ReturnQuantity: initialRecord ? initialRecord.ReturnQuantity : '',
                    },
                ]);
            });
        } catch (error) {
            console.error('Error adding record to table:', error);
            toast.error(`Error adding record to table: ${error.message}`);
        }
    };

    const handleSubmit = async (event) => {
        event.preventDefault();
        try {
            let isValid = true;
            if (returnReason === '') {
                setIsReasonEmpty(true);
                isValid = false;
            }
            if (selectedLogisticPartyId === '') {
                setIsLogisticEmpty(true);
                isValid = false;
            }
            if (tableRecords.length <= 0) {
                toast.error('You need to add at least one shipment to save return shipment.');
                isValid = false;
            }
            if (!isValid) return;

            for (const item of tableRecords) {
                if (item.ReturnQuantity === '' || parseInt(item.ReturnQuantity) <= 0) {
                    toast.error(`Please Enter Return Quantity for Product: ${item.ProductName} (Product Code: ${item.ProductCode}).`);
                    return;
                }
            }

            const initialQuantities = {};
            initialTableRecords.forEach((record) => {
                if (!initialQuantities[record.ProductCode]) initialQuantities[record.ProductCode] = 0;
                initialQuantities[record.ProductCode] += parseInt(record.ReturnQuantity);
            });

            const currentQuantities = {};
            tableRecords.forEach((record) => {
                if (!currentQuantities[record.ProductCode]) currentQuantities[record.ProductCode] = 0;
                currentQuantities[record.ProductCode] += parseInt(record.ReturnQuantity);
            });

            const blockQtyUpdates = Object.keys({ ...initialQuantities, ...currentQuantities }).map((productCode) => {
                const initialQty = initialQuantities[productCode] || 0;
                const currentQty = currentQuantities[productCode] || 0;
                const blockQty = currentQty - initialQty;
                console.log(`Product Code: ${productCode}, Initial Qty: ${initialQty}, Current Qty: ${currentQty}, Difference: ${blockQty}`);
                return { productCode, blockQty };
            });

            for (const update of blockQtyUpdates) {
                const response = await fetch(`${config.API_URL}/inventory/updateBlockQty`, {
                    method: 'PATCH',
                    headers: { 'Content-Type': 'application/json' },
                    body: JSON.stringify({
                        blockQty: update.blockQty,
                        scpid: selectedScpId,
                        productCode: update.productCode,
                    }),
                });
                if (!response.ok) {
                    const errorData = await response.json();
                    throw new Error(errorData.error || 'Failed to update block quantity');
                }
                console.log(`Block Qty updated successfully for Product Code: ${update.productCode}`);
            }

            const missingRecords = initialTableRecords.filter((initialItem) => {
                const found = tableRecords.some((tableItem) => {
                    const isMatch = tableItem.SHPD_ShipmentMID === initialItem.SHPD_ShipmentMID;
                    console.log(`Comparing tableItem: ${JSON.stringify(tableItem)} with initialItem: ${JSON.stringify(initialItem)}`);
                    console.log(`Match: ${isMatch}`);
                    return isMatch;
                });
                console.log(`InitialItem: ${JSON.stringify(initialItem)} found: ${found}`);
                return !found;
            });

            console.log('Missing Records:', missingRecords);

            for (const record of [...tableRecords, ...missingRecords]) {
                const returnQty = missingRecords.includes(record)
                    ? parseInt(record.RemainingQuantity) + parseInt(record.ReturnQuantity)
                    : parseInt(record.RemainingQuantity);

                const response = await fetch(`${config.API_URL}/returnshipment/update/returnqty`, {
                    method: 'PATCH',
                    headers: { 'Content-Type': 'application/json' },
                    body: JSON.stringify({
                        returnQty,
                        shipmentCode: record.ShipmentCode,
                        productCode: record.ProductCode,
                    }),
                });
                if (!response.ok) {
                    const errorData = await response.json();
                    throw new Error(errorData.error || 'Failed to update return quantity');
                }
                console.log(`Return Qty updated successfully for Product Code: ${record.ProductCode}`);
            }

            const payload = {
                UM_GroupId,
                UM_CompanyGrpID,
                UM_CompanyID,
                UM_UserId,
                UM_UserCode,
                shipmentCode,
                returnReason,
                shipmentDate,
                logisticPartyId: selectedLogisticPartyId,
                logisticVehicleId: vehicleNumber,
                SCPCode: selectedSCPCode,
                returnRemarks: text,
                tableRecords: tableRecords.map((record) => ({
                    ...record,
                    ReturnQuantity: parseInt(record.ReturnQuantity),
                })),
            };

            console.log('PAYLOAD', payload);

            const response = await fetch(`${config.API_URL}/shipmentreturnupdate/${shipmentCode}`, {
                method: 'PATCH',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify(payload),
            });

            if (!response.ok) {
                const errorData = await response.json();
                throw new Error(errorData.error || 'Failed to submit shipment return');
            }

            setLoading(true);
            toast.success(`Return Shipment : ${shipmentCode} updated successfully.`, {
                onClose: () => {
                    navigate('/dashboard/shipmentreturn');
                    setLoading(false);
                },
            });

            try {
                const notificationResponse = await fetch(`${config.API_URL}/notificationmaster/save`, {
                    method: 'POST',
                    headers: { 'Content-Type': 'application/json' },
                    body: JSON.stringify({
                        NFM_EventType: 'Shipment Creation',
                        NFM_EventBy: UM_UserId,
                        NFM_Status: 0,
                        NFM_EventMessage: `Return Shipment with Shipment code: '${shipmentCode}' is updated successfully`,
                        NFM_CompanyID: UM_CompanyID,
                        NFM_CompanyGrpID: UM_CompanyGrpID,
                        NFM_SCPID: selectedScpId,
                    }),
                });
                if (!notificationResponse.ok) throw new Error('Failed to save notification');
            } catch (notificationError) {
                console.error('Error saving notification:', notificationError);
                toast.error('Some problem occurred while saving the notification.');
            }
        } catch (error) {
            console.error('Error submitting shipment return:', error);
            toast.error('Failed to submit shipment return');
        }
    };

    const handleReset = () => {
        setReturnReason('');
        setIsSCPNameEmpty(false);
        setIsLogisticEmpty(false);
        setIsShipmentCodeEmpty(false);
        setIsReasonEmpty(false);
        setSelectedSCPName('');
        setVehicleNumber('');
        setSelectedLogisticPartyId('');
        setTableRecords([]);
        setText('');
    };

    const handleReturnReason = (selectedOption) => {
        const returnReason = selectedOption ? selectedOption.value : '';
        setReturnReason(returnReason);
    };

    const handleDateChange = (date) => {
        setModalSelectedDate(date);
        setShowModal(true);
    };

    const handleModalCancel = () => {
        setShowModal(false);
    };

    const handleModalConfirm = () => {
        setShipmentDate(modalSelectedDate);
        localStorage.setItem('shipmentDate', modalSelectedDate);
        setShowModal(false);
    };

    const handleVehicle = (selectedOption) => {
        const vehicle = selectedOption ? selectedOption.value : '';
        setVehicleNumber(vehicle);
    };

    const handleReturnQuantityChange = (e, index) => {
        let returnQty = parseInt(e.target.value);
        const updatedRecords = [...tableRecords];
        const originalReturnQty = parseInt(updatedRecords[index].originalReturnQty);
        console.log('originalReturnQty', originalReturnQty);

        if (e.target.value === '') returnQty = 0;
        if (returnQty < 0) return;

        if (!isNaN(returnQty) && returnQty >= 0 && returnQty <= updatedRecords[index].originalRemainingQty + originalReturnQty) {
            updatedRecords[index].ReturnQuantity = returnQty;
            updatedRecords[index].RemainingQuantity = updatedRecords[index].originalRemainingQty - returnQty + originalReturnQty;
        } else {
            toast.error(`Quantity cannot exceed the remaining quantity of ${updatedRecords[index].originalRemainingQty + originalReturnQty}.`);
        }
        setTableRecords(updatedRecords);
    };

    const handleConfirmRemove = (index) => {
        setConfirmRemoveIndex(index);
        setShowConfirmModal(true);
    };

    const handleCancelRemove = () => {
        setConfirmRemoveIndex(null);
        setShowConfirmModal(false);
    };

    const handleRemoveRecord = () => {
        const updatedRecords = [...tableRecords];
        updatedRecords.splice(confirmRemoveIndex, 1);
        setTableRecords(updatedRecords);
        setConfirmRemoveIndex(null);
        setShowConfirmModal(false);
    };

    const returnReasonOptionsFormatted = returnReasonOptions.map((option) => ({
        value: option.enumVal,
        label: option.description,
    }));

    const logisticPartyOptions = logisticParty.map((party) => ({
        value: party.LGCM_ID,
        label: party.LGCM_Name,
    }));

    const vehicleOptionsFormatted = vehicleOptions.map((vehicle) => ({
        value: vehicle.LGCVM_ID,
        label: vehicle.LGCVM_VehicleNumber,
    }));

    const scpOptionsFormatted = scpOptions.map((scp) => ({
        value: scp.SCPM_Name,
        label: scp.SCPM_Name,
    }));

    const shipmentCodeOptions = shipmentCodes.map((code) => ({
        value: code,
        label: code,
    }));

    return (
        <>
            <ToastContainer
                style={{
                    marginTop: '73px',
                    fontSize: '14px',
                    width: '40%',
                }}
            />
            {loading && (
                <div
                    style={{
                        position: 'fixed',
                        left: 0,
                        top: 0,
                        width: '100%',
                        height: '100%',
                        zIndex: 1000,
                    }}
                />
            )}
            <form autoComplete="off">
                <div className="main_container">
                    <h1 className="formHeading">Shipment Return</h1>
                    <div className="row">
                        <div className="col-sm-4">
                            <label htmlFor="shipmentType">Shipment Type</label>
                            <input
                                type="text"
                                id="shipmentType"
                                name="shipmentType"
                                value="Return"
                                className="form-input"
                                style={{
                                    backgroundColor: '#f2f2f2',
                                    color: '#6c757d',
                                }}
                                disabled
                            />
                        </div>
                        <div className="col-sm-4">
                            <label htmlFor="returnReason">
                                Return Reason<span style={{ color: 'red' }}>{isReasonEmpty ? ' *' : ''}</span>
                            </label>
                            <div className="select-container">
                                <Select
                                    className="routing_select-box"
                                    options={returnReasonOptionsFormatted}
                                    value={returnReasonOptionsFormatted.find((opt) => opt.value === returnReason) || null}
                                    onChange={handleReturnReason}
                                    placeholder="--Select--"
                                    onMenuOpen={() => handleSelectOpen('returnReason')}
                                    onMenuClose={handleSelectClose}
                                />
                                <div className="icon-container_list myList">
                                    <i>{isSelectOpen === 'returnReason' ? <IoCaretUpOutline /> : <IoCaretDownOutline />}</i>
                                </div>
                            </div>
                        </div>
                        <div className="col-sm-4">
                            <label htmlFor="shipmentDate">Shipment Date</label>
                            <DatePicker
                                selected={shipmentDate}
                                onChange={handleDateChange}
                                dateFormat="dd-MM-yyyy"
                                onKeyDown={(e) => e.preventDefault()}
                            />
                        </div>
                        {/* <Modal backdrop="static" show={showModal} onHide={handleModalCancel} centered>
                            <Modal.Header>
                                <Modal.Title
                                    style={{
                                        fontSize: '18px',
                                        fontWeight: 'bold',
                                        color: '#465a64',
                                        margin: 'auto',
                                    }}
                                >
                                    :: User Confirmation ::
                                </Modal.Title>
                            </Modal.Header>
                            <Modal.Body
                                style={{
                                    fontSize: '18px',
                                    fontWeight: '500',
                                    color: '#465a64',
                                    margin: 'auto',
                                }}
                            >
                                Are you sure you want to change the date?
                            </Modal.Body>
                            <div className="popup_btn_container">
                                <button className="yes_btn" onClick={handleModalConfirm}>
                                    YES
                                </button>
                                <button className="no_btn" onClick={handleModalCancel}>
                                    NO
                                </button>
                            </div>
                        </Modal> */}
                        {showModal && (
                            <div className="popup_overlay">
                                <div className="resetpopup">
                                    <h1>:: User Confirmation ::</h1>
                                    <h4>Are you sure you want to change the date ?</h4>
                                    <div className="popup_btn_container">
                                        <button className="yes_btn " onClick={handleModalConfirm}>
                                            YES
                                        </button>
                                        <button className="no_btn " onClick={handleModalCancel}>
                                            NO
                                        </button>
                                    </div>
                                </div>
                            </div>
                        )}
                        <div className="col-sm-4">
                            <label className="form-label">
                                Logistic Party Name<span style={{ color: 'red' }}>{isLogisiticEmpty ? ' *' : ''}</span>
                            </label>
                            <div className="select-container">
                                <Select
                                    className="routing_select-box"
                                    options={logisticPartyOptions}
                                    value={logisticPartyOptions.find((opt) => opt.value === selectedLogisticPartyId) || null}
                                    onChange={handleLogisticPartyChange}
                                    placeholder="--Select--"
                                    onMenuOpen={() => handleSelectOpen('logisticParty')}
                                    onMenuClose={handleSelectClose}
                                />
                                <div className="icon-container_list myList">
                                    <i>{isSelectOpen === 'logisticParty' ? <IoCaretUpOutline /> : <IoCaretDownOutline />}</i>
                                </div>
                            </div>
                        </div>
                        <div className="col-sm-4 row">
                            <div className="col-md-11">
                                <label className="form-label">Vehicle Number</label>
                                <div className="select-container">
                                    <Select
                                        className="routing_select-box"
                                        options={vehicleOptionsFormatted}
                                        value={vehicleOptionsFormatted.find((opt) => opt.value === vehicleNumber) || null}
                                        onChange={handleVehicle}
                                        placeholder="--Select--"
                                        onMenuOpen={() => handleSelectOpen('vehicleNumber')}
                                        onMenuClose={handleSelectClose}
                                    />
                                    <div className="icon-container_list myList">
                                        <i>{isSelectOpen === 'vehicleNumber' ? <IoCaretUpOutline /> : <IoCaretDownOutline />}</i>
                                    </div>
                                </div>
                            </div>
                            <div className="col-md-1">
                                <Link to={`/dashboard/lgcm`}>
                                    <img
                                        title="Create Vehicle"
                                        src={add}
                                        alt="Add All Icon"
                                        style={{
                                            width: '19px',
                                            height: '19px',
                                            marginTop: '41px',
                                        }}
                                    />
                                </Link>
                            </div>
                        </div>
                        <div className="ms-4 col-md-4 mt-2">
                            <label className="form-label">Shipment Status</label>
                            <input
                                type="text"
                                className="form-input"
                                style={{
                                    backgroundColor: '#f2f2f2',
                                    color: '#6c757d',
                                }}
                                value="Created"
                                disabled
                            />
                        </div>

                        <div className="col-md-4 mt-2">
                            <label htmlFor="shipment">
                                SCP Name<span style={{ color: 'red' }}>{isSCPNameEmpty ? ' *' : ''}</span>
                            </label>
                            <div className="select-container">
                                <Select
                                    className="routing_select-box"
                                    options={scpOptionsFormatted}
                                    value={scpOptionsFormatted.find((opt) => opt.value === selectedSCPName) || null}
                                    onChange={handleSCPChange}
                                    placeholder="--Select--"
                                    onMenuOpen={() => handleSelectOpen('scpName')}
                                    onMenuClose={handleSelectClose}
                                />
                                <div className="icon-container_list myList">
                                    <i>{isSelectOpen === 'scpName' ? <IoCaretUpOutline /> : <IoCaretDownOutline />}</i>
                                </div>
                            </div>
                        </div>

                        <div className="col-md-4 row mt-2">
                            <div className="col-md-11">
                                <label htmlFor="shipmentCode">
                                    Shipment Code<span style={{ color: 'red' }}>{isShipmentCodeEmpty && ' *'}</span>
                                </label>
                                <div className="select-container">
                                    <Select
                                        className="routing_select-box"
                                        options={shipmentCodeOptions}
                                        value={shipmentCodeOptions.find((opt) => opt.value === selectedShipmentCode) || null}
                                        onChange={handleShipmentCodeChange}
                                        placeholder="--Select--"
                                        onMenuOpen={() => handleSelectOpen('shipmentCode')}
                                        onMenuClose={handleSelectClose}
                                    />
                                    <div className="icon-container_list myList">
                                        <i>{isSelectOpen === 'shipmentCode' ? <IoCaretUpOutline /> : <IoCaretDownOutline />}</i>
                                    </div>
                                </div>
                            </div>
                            <div className="col-md-1">
                                <img
                                    src={add}
                                    onClick={handleAddAllToTable}
                                    alt="Add All"
                                    title="Add All"
                                    style={{
                                        width: '19px',
                                        height: '19px',
                                        marginTop: '41px',
                                    }}
                                />
                            </div>
                        </div>
                        <div className="row">
                            <div className="col-md-4">
                                <label htmlFor="returnComment">Return Comment</label>
                                <textarea
                                    id="returnComment"
                                    name="returnComment"
                                    value={text}
                                    onChange={handleChange}
                                    rows="3"
                                    style={{
                                        border: '1px solid rgb(206, 212, 218)',
                                        padding: '10px',
                                        width: '100%',
                                        resize: 'none',
                                        overflow: 'auto',
                                        transition: 'height 0.3s ease 0s',
                                        borderRadius: '5px',
                                        maxHeight: '100px',
                                        height: '230px',
                                        color: '#465a64',
                                        fontSize: '14px',
                                        fontWeight: '500',
                                        outline: 'none',
                                    }}
                                    placeholder="Enter Return Comment"
                                />
                            </div>
                            <div className="col-md-8">
                                <button type="button" className="shipment_add_btn" onClick={handleAddToTable}>
                                    ADD
                                </button>
                            </div>
                        </div>
                    </div>
                    {tableRecords.length > 0 && (
                        <div className="table_div mt-3">
                            <table className="tableClass">
                                <thead>
                                    <tr>
                                        <th>Sr. No.</th>
                                        <th>SCP Name</th>
                                        <th>Shipment Code</th>
                                        <th>Product Name</th>
                                        <th>Product Code</th>
                                        <th>Received Quantity</th>
                                        <th>Remaining Quantity</th>
                                        <th>Return Quantity</th>
                                        <th>Action</th>
                                        <th style={{ display: 'none' }}>SCP Code</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {tableRecords.map((record, index) => (
                                        <tr key={index}>
                                            <td>{index + 1}</td>
                                            <td>{record.SCPName}</td>
                                            <td>{record.ShipmentCode}</td>
                                            <td>{record.ProductName}</td>
                                            <td>{record.ProductCode}</td>
                                            <td>{record.ReceivedQuantity}</td>
                                            <td>{record.RemainingQuantity}</td>
                                            <td>
                                                <input
                                                    type="number"
                                                    value={record.ReturnQuantity === 0 ? '' : record.ReturnQuantity}
                                                    onChange={(e) => handleReturnQuantityChange(e, index)}
                                                    onKeyDown={(e) => {
                                                        const allowedKeys = ['Backspace', 'Delete', 'ArrowLeft', 'ArrowRight', 'Tab'];
                                                        if (allowedKeys.includes(e.key)) return;
                                                        if (!/^[0-9]$/.test(e.key)) e.preventDefault();
                                                    }}
                                                />
                                                {invalidQuantities.includes(index) && (
                                                    <span style={{ color: 'red', fontSize: '0.8rem' }}>Invalid return quantity</span>
                                                )}
                                            </td>
                                            <td>
                                                <img
                                                    src={Icon5}
                                                    title="Remove"
                                                    onClick={() => handleConfirmRemove(index)}
                                                    className="suspendicon"
                                                    alt="suspend"
                                                />
                                            </td>
                                            <td style={{ display: 'none' }}>{record.SCPCode}</td>
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                        </div>
                    )}
                    {/* <Modal backdrop="static" show={showConfirmModal} onHide={handleCancelRemove} centered>
                        <Modal.Header>
                            <Modal.Title
                                style={{
                                    fontSize: '18px',
                                    fontWeight: 'bold',
                                    color: '#465a64',
                                    margin: 'auto',
                                }}
                            >
                                :: User Confirmation ::
                            </Modal.Title>
                        </Modal.Header>
                        <Modal.Body
                            style={{
                                fontSize: '18px',
                                fontWeight: '500',
                                color: '#465a64',
                                margin: 'auto',
                            }}
                        >
                            Are you sure you want to remove this record?
                        </Modal.Body>
                        <div className="popup_btn_container">
                            <button className="yes_btn" onClick={handleRemoveRecord}>
                                YES
                            </button>
                            <button className="no_btn" onClick={handleCancelRemove}>
                                NO
                            </button>
                        </div>
                    </Modal> */}
                    {showConfirmModal && (
                        <div className="popup_overlay">
                            <div className="resetpopup">
                                <h1>:: User Confirmation ::</h1>
                                <h4>Are you sure you want to remove this row ?</h4>
                                <div className="popup_btn_container">
                                    <button className="yes_btn " onClick={handleRemoveRecord}>
                                        YES
                                    </button>
                                    <button className="no_btn " onClick={handleCancelRemove}>
                                        NO
                                    </button>
                                </div>
                            </div>
                        </div>
                    )}
                </div>
                <div className="button-container">
                    <button type="submit" className="save_btn" onClick={handleSubmit}>
                        SAVE
                    </button>
                    <button type="button" onClick={handleReset} className="reset_btn">
                        RESET
                    </button>
                    <Link to={`/shipmentreturnlist`} className="list_btn" type="button">
                        LIST
                    </Link>
                </div>
            </form>
        </>
    );
}

export default ShipmentReturnUpdate;